import { ItemAPI } from "../ApiStore/apiStore";

const SET_ITEM = "SET-ITEM";
const TOGGLE_IS_DISPETCHER_ITEM = "TOGGLE-IS-DISPETCHER-ITEM";
const SET_ITEM_COLOR_SEMILAR = "SET-ITEM-COLOR-SEMILAR";
const SET_ITEM_ARTYCLES_SEMILAR = "SET-ITEM-ARTYCLES-SEMILAR";
const SET_ITEM_SMILARAIS_SEMILAR = "SET-ITEM-SMILARAIS-SEMILAR";
const SET_ITEM_COLLECTION_SEMILAR = "SET-ITEM-COLLECTION-SEMILAR";
const SET_ITEM_SERIES_SEMILAR = "SET-ITEM-SERIES-SEMILAR";
const SET_ITEM_COLORID_SEMILAR = "SET-ITEM-COLORID-SEMILAR";
const TOGGLE_IS_OPENSHOP_ITEM = "TOGGLE-IS-OPENSHOP-ITEM";
const SET_COUNT_ITEM_BAY = "SET-COUNT-ITEM-BAY";


let initialState = {
    item: [],
    isFetchingItem: false,
    isOpenShop: false,
    colorSemilar: [],
    smilaraiSemilar: [],
    smilaraiSemilarCount: "",
    articlesSemilar: [],
    articlesSemilarCount: "",
    collectionSemilar: [],
    collectionSemilarCount: "",
    seriesSemilar: [],
    seriesSemilarCount: "",
    coloridSemilar: [],
    coloridSemilarCount: "",
    countBay: 1

}

const itemReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_ITEM: {

            return {
                ...state,
                item: action.item
            }
        }
        case SET_ITEM_COLOR_SEMILAR: {

            return {
                ...state,
                colorSemilar: action.color
            }
        }
        case SET_ITEM_SMILARAIS_SEMILAR: {

            return {
                ...state,
                smilaraiSemilar: action.smilarai.PROPERTIES,
                smilaraiSemilarCount: action.smilarai.resElemCnt
            }
        }
        case SET_ITEM_ARTYCLES_SEMILAR: {

            return {
                ...state,
                articlesSemilar: action.article.PROPERTIES,
                articlesSemilarCount: action.article.resElemCnt
            }
        }
        case SET_ITEM_COLLECTION_SEMILAR: {

            return {
                ...state,
                collectionSemilar: action.collection.PROPERTIES,
                collectionSemilarCount: action.collection.resElemCnt
            }
        }
        case SET_ITEM_SERIES_SEMILAR: {

            return {
                ...state,
                seriesSemilar: action.series.PROPERTIES,
                seriesSemilarCount: action.series.resElemCnt
            }
        }
        case SET_ITEM_COLORID_SEMILAR: {

            return {
                ...state,
                coloridSemilar: action.colorid.PROPERTIES,
                coloridSemilarCount: action.colorid.resElemCnt
            }
        }
        case TOGGLE_IS_DISPETCHER_ITEM: {

            return {
                ...state,
                isFetchingItem: action.isFetchingItem
            }
        }
        case TOGGLE_IS_OPENSHOP_ITEM: {

            return {
                ...state,
                isOpenShop: action.isOpenShop
            }
        }
        case SET_COUNT_ITEM_BAY: {

            return {
                ...state,
                countBay: action.countBay
            }
        }
        default: {
            return state;
        }
    }
}
export const setItemAC = (item) => {

    return {
        type: SET_ITEM, item
    }
}
export const setItemColorSemilarAC = (color) => {

    return {
        type: SET_ITEM_COLOR_SEMILAR, color
    }
}
export const setItemColorIdSemilarAC = (colorid) => {

    return {
        type: SET_ITEM_COLORID_SEMILAR, colorid
    }
}
export const setItemColorSeriesSemilarAC = (series) => {

    return {
        type: SET_ITEM_SERIES_SEMILAR, series
    }
}
export const setItemColorCollectionSemilarAC = (collection) => {

    return {
        type: SET_ITEM_COLLECTION_SEMILAR, collection
    }
}
export const setItemColorArtyclesSemilarAC = (article) => {

    return {
        type: SET_ITEM_ARTYCLES_SEMILAR, article
    }
}
export const setItemColorSmilaraiSemilarAC = (smilarai) => {

    return {
        type: SET_ITEM_SMILARAIS_SEMILAR, smilarai
    }
}
export const settoggleDispetcherItem = (isFetchingItem) => {
    return {
        type: TOGGLE_IS_DISPETCHER_ITEM, isFetchingItem
    }
}
export const settoggleOpenShopItem = (isOpenShop) => {
    return {
        type: TOGGLE_IS_OPENSHOP_ITEM, isOpenShop
    }
}
export const setCountItemBay = (countBay) => {
    return {
        type: SET_COUNT_ITEM_BAY, countBay
    }
}
export const getItem = (itemUrlCod) =>

    async (dispatch) => {
        dispatch(settoggleDispetcherItem(false));
        let data = await ItemAPI.GetItemUrlCod(itemUrlCod);
        dispatch(setItemAC(data.item));
        dispatch(setItemColorSemilarAC(data.color.PROPERTIES));
        dispatch(setItemColorIdSemilarAC(data.colorid));
        dispatch(setItemColorSeriesSemilarAC(data.series));
        dispatch(setItemColorCollectionSemilarAC(data.collection));
        dispatch(setItemColorArtyclesSemilarAC(data.articles));
        dispatch(setItemColorSmilaraiSemilarAC(data.smilarai));
        dispatch(settoggleDispetcherItem(true));

    }

    export default itemReducer;